import { render } from "./ParcourSup.vue?vue&type=template&id=9fbe01ca&scoped=true&ts=true"
import script from "./ParcourSup.vue?vue&type=script&lang=ts"
export * from "./ParcourSup.vue?vue&type=script&lang=ts"

import "./ParcourSup.vue?vue&type=style&index=0&id=9fbe01ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fbe01ca"]])

export default __exports__